/* Native touch scrolling, keyboard and discrete buttons; never auto-advance. */
(() => {
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 document.querySelectorAll('[data-detail-carousel]').forEach(root=>{if(root.dataset.carouselReady)return;root.dataset.carouselReady='true';
  const track=root.querySelector('.detail-track'),cards=[...track.children],controls=root.querySelector('.detail-controls');
  const dots=root.querySelector('.detail-dots'),prev=root.querySelector('[data-detail-prev]'),next=root.querySelector('[data-detail-next]'),status=root.querySelector('.detail-status');
  let stops=[],active=0,frame=0;
  function sync(){
   const x=track.scrollLeft;active=stops.reduce((best,v,i)=>Math.abs(v-x)<Math.abs(stops[best]-x)?i:best,0);
   prev.disabled=x<=2;next.disabled=x>=track.scrollWidth-track.clientWidth-2;
   [...dots.children].forEach((b,i)=>b.setAttribute('aria-current',String(i===active)));
  }
  function go(index){index=Math.max(0,Math.min(stops.length-1,index));track.scrollTo({left:stops[index],behavior:reduced.matches?'instant':'smooth'});status.textContent=`Detail position ${index+1} of ${stops.length}`;}
  function measure(){
   const max=Math.max(0,track.scrollWidth-track.clientWidth),first=cards[0].getBoundingClientRect().left;
   const positions=cards.map(c=>Math.min(max,Math.max(0,Math.round(c.getBoundingClientRect().left-first))));
   const fresh=[...new Set(positions)];
   if(fresh.length!==stops.length){dots.replaceChildren(...fresh.map((_,i)=>{const b=document.createElement('button');b.type='button';b.setAttribute('aria-label',`Show detail position ${i+1}`);b.setAttribute('aria-controls',track.id);b.addEventListener('click',()=>go(i));return b;}));}
   stops=fresh;controls.hidden=max<=2;sync();
  }
  prev.addEventListener('click',()=>go(active-1));next.addEventListener('click',()=>go(active+1));
  track.addEventListener('keydown',e=>{if(e.target!==track)return;const keys={ArrowLeft:active-1,ArrowRight:active+1,Home:0,End:stops.length-1};if(e.key in keys){e.preventDefault();go(keys[e.key]);}});
  track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(sync);},{passive:true});
  if('ResizeObserver' in window)new ResizeObserver(measure).observe(track);else window.addEventListener('resize',measure);
  measure();
 });
})();

